@if (false) {
  <div class="flex flex-1 flex-col p-2 pt-0 bg-slate-50">
    <!-- container -->
    <div
      class="flex-1 flex flex-col rounded-md border bg-white border-slate-200"
    >
      <!-- header -->
      <div class="flex flex-row border-b border-slate-200">
        @for (column of columns; track column) {
          <div
            [ngClass]="{
              'flex-1': column.expand
            }"
            class="p-2 {{ column.cssClass }}"
          >
            {{ column.caption }}
          </div>
        }
      </div>
      <!-- body -->
      <div class="flex flex-col flex-1 relative">
        <div class="absolute inset-0 overflow-auto">
          @for (template of $any([]); track template) {
            <div class="flex flex-row border-b border-slate-200"></div>
          }
        </div>
      </div>
    </div>
  </div>
}

<div class="flex-1 relative">
  <div class="absolute inset-0 overflow-auto rounded-md">
    <cdk-table [dataSource]="dataSource">
      @for (column of columns; track column) {
        <ng-container [cdkColumnDef]="column.name">
          <cdk-header-cell
            *cdkHeaderCellDef
            [ngClass]="{ 'flex-1': column.expand }"
            class="flex p-2 {{ column.cssClass }}"
            [ngStyle]="{
              width: column.width ? column.width + 'px' : null
            }"
            ><div
              class="flex-1 flex"
              [ngClass]="{
                'justify-start': column.alignCaption === 'start',
                'justify-center': column.alignCaption === 'center',
                'justify-end': column.alignCaption === 'end'
              }"
            >
              <span class="text-xs text-slate-400">{{ column.caption }}</span>
            </div></cdk-header-cell
          >
          <cdk-cell
            *cdkCellDef="let row"
            [ngClass]="{ 'flex-1': column.expand }"
            class="{{ column.cssClass }}"
            [ngStyle]="{
              width: column.width ? column.width + 'px' : null
            }"
          >
            <div
              class="flex-1 flex"
              [ngClass]="{
                'p-0': column.padding === '0',
                'p-1': column.padding === '1',
                'p-2': column.padding === '2'
              }"
            >
              @if (!column.template) {
                {{ row[column.valueExpr] }}
              }
              @if (column.template) {
                <ng-container
                  [ngTemplateOutlet]="column.template.templateRef"
                  [ngTemplateOutletContext]="{ row: row }"
                ></ng-container>
              }
            </div>
          </cdk-cell>
        </ng-container>
      }

      <!-- Header and Row Declarations -->
      <cdk-header-row *cdkHeaderRowDef="showedColumns"></cdk-header-row>
      <cdk-row *cdkRowDef="let row; columns: showedColumns"></cdk-row>
    </cdk-table>
  </div>
</div>
